import { useCallback, useMemo } from "react"
import { useDeleteConfirm } from "../../../../hooks/useDeleteConfirm"
import { useFactories } from "../../../../hooks/useFactories"
import { DimaFeatureShortNameEnum } from "../../../models/Authorization"
import { FactoryGet, FactoryTypeEnum } from "../../../models/Factory"
import { deleteEntity } from "../../../utils/deleteEntity"
import { booleanComparator, getDoneIcon, getEmptyIcon } from "../../../utils/getBooleanFlagIcon"
import { DiMaAddButton } from "../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../partials/EntityTab"

export function Factories() {
  const { factories, isLoadingFactories } = useFactories()
  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()

  const columns = [
    {
      field: "name",
      headerName: "Name",
      isLink: true,
      linkBasePath: "/factory-reports/factories",
    },
    { field: "type", headerName: "Type" },
    {
      field: "isFree",
      headerName: "Is Free",
      renderCell: (row: EntityRow) => row.isFree ? getDoneIcon() : getEmptyIcon(),
      sortComparator: booleanComparator,
    },
    {
      field: "isEnabled",
      headerName: "Is Enabled",
      renderCell: (row: EntityRow) => row.isEnabled ? getDoneIcon() : getEmptyIcon(),
      sortComparator: booleanComparator,
    },
    { field: "maxDays", headerName: "Max Days" },
  ]

  const sorted = [...factories].sort((a, b) => (a.name ?? "").localeCompare(b.name ?? ""))

  const rows = sorted.map((factory: FactoryGet) => ({
    id: factory.id,
    name: factory.name,
    type: (FactoryTypeEnum as Record<string, FactoryTypeEnum>)[factory.type],
    isFree: factory.isFree,
    isEnabled: factory.isEnabled,
    maxDays: factory.maxDays,
  }))

  const toolbar = useMemo(
    () => (
      <DiMaAddButton
        url="/factory-reports/factories/create"
        feature={DimaFeatureShortNameEnum.FR}
      />
    ),
    []
  )

  const handleActionMenuClick = useCallback(
    (item: { title: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        requestDelete(() => deleteEntity(`/factories/${row.id}`))
      }
    },
    [requestDelete]
  )

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
        rows={rows}
        cols={columns}
        isLoading={isLoadingFactories}
        toolbar={toolbar}
        actionItems={[{ title: "Delete", iconName: "icon_abb_dias icon-abb_delete" }]}
        onActionMenuClick={handleActionMenuClick}
      />
    </>
  )
}
